export const iconFontAwesomeMedicalHealthBong = (
	<i className="fa-solid fa-bong"></i>
);
